import { connect } from "react-redux";
import { DetailsSubHeader } from "../../../../components/sectionHeader";
import { type Props as DetailsSubHeaderProps } from "../../../../components/sectionHeader/sectionSubHeader/SectionSubHeader";
import { type RootState } from "../../../Application/globaltypes/redux";

const mapStateToProps = (state: RootState, ownProps: DetailsSubHeaderProps & { showLastModified: boolean }) => {
  const scorm = state.library.scorm;
  return {
    isUpdateInProgress: scorm.entityState.isEntityCommandInProgress && ownProps.isUpdateInProgress,
    lastModifiedDateTime: ownProps.showLastModified
      ? scorm.entityState.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
      : undefined,
  };
};

export default connect(mapStateToProps)(DetailsSubHeader);
